export const pcPageConfig = {
  "name": "CommonHeader",
  "isRender": true,
  "className": "dbd-scroll-body",
  "data": {
    "catalog": {
      "values": [
        "255"
      ],
      "gameSelectedInfo": null
    },
    "catalogTooltipMap": {
      "Backcatalog": {
        "en": "Titles developed by Techland outside of the Dying Light franchise, including Call of Juarez, God's Trigger, Crime Cities etc.",
        "cn": "由 Techland 在《消逝的光芒》( Dying Light) 系列之外开发的作品，包括《狂野西部》(Call of Juarez)、《神之扳机》(God's Trigger)、《罪恶都市》(Crime Cities) 等。"
      },
      "Special Deals": {
        "en": "Revenue from third-party digital distribution, licensing, and subscription partners (e.g., Metaboli, Genba Digital, Nexway, Voidu, Amazon, and others).",
        "cn": "来自第三方数字分销、授权许可及订阅合作伙伴的收入（例如 Metaboli、Genba Digital、Nexway、Voidu、Amazon 等其他合作方）。"
      }
    }
  },
  "config": {
    "title": "Sales Overview",
    "titleCn": "销售概览",
    "headerSlot": [
      {
        "name": "GameSelector",
        "style": {
          "marginBottom": "6px",
          "marginTop": "10px"
        },
        "props": {
          "defaultValue": [
            "255"
          ],
          "optionAll": {
            "value": "255",
            "image": "https://ogdb-cdn.intlgame.cn/front/static/img/studio/techland-logo-white.jpg"
          },
          "fallbackImageMap": {
            "Backcatalog": "https://ogdb-cdn.intlgame.cn/front/static/img/studio/backcatalog-logo.jpg",
            "Special Deals": "https://ogdb-cdn.intlgame.cn/front/static/img/studio/special-sales-logo.jpg"
          },
          "mode": "multiple"
        }
      }
    ]
  },
  "children": [
    {
      "name": "CommonContantWrap",
      "config": {
        "isHaveNotification": true,
        "notificationPath": "/monetization/salesOverview",
        "logConfig": {
          "pageId": "204101",
          "pageName": "salesOverview",
          "extInfo": "salesOverview",
          "pagePath": "/monetization/salesOverview/revenue"
        }
      },
      "children": [
        {
          "name": "FilterWrap",
          "props": {
            "filterIndex": 0,
            "pagePath": "/monetization/salesOverview/revenue",
            "timeZone": "+0",
            "config": {
              "name": "SalesOverviewFilter",
              "isOpenSticky": true,
              "isHaveFilterSave": true,
              "filterPath": "/monetization/salesOverview/revenue",
              "systemCascadeBoxClassName": "dbd-techland-platform-cascade",
              "selectorConfig": {
                "api": "/api/v1/dashboard/pc/customized/selector",
                "otherParams": {
                  "path": "/monetization/salesOverview/revenue"
                }
              },
              "componentList": [
                {
                  "name": "MetricInfo",
                  "data": {
                    "by_tab": "net",
                    "cardTitleSwitchVal": "net",
                    "platform_country_dimension": "platform",
                    "by_type": "product"
                  },
                  "children": [
                    {
                      "name": "PlatformMetricsCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "style": {},
                      "props": {
                        "disableLoading": true,
                        "config": {
                          "metricsSwitchKey": "by_tab",
                          "api": "/api/v1/dashboard/pc/monetization/sales/overview/card_metrics",
                          "metricsList": [
                            "net_full_game_units",
                            "profit",
                            "refund_rate"
                          ],
                          "metricsListMap": {
                            "net": [
                              "net_full_game_units",
                              "profit",
                              "refund_rate"
                            ],
                            "gross": [
                              "gross_full_game_units",
                              "gross_revenue"
                            ]
                          },
                          "otherParams": {
                            "breakdown_dimension": "catalog",
                            "logical_flag": "top_no_others"
                          },
                          "isSalesOverview": true,
                          "dateFilterIsRange": true
                        }
                      },
                      "children": [
                        {
                          "name": "HaveDataDateRange",
                          "className": "margin-t-20 margin-b-20",
                          "style": {},
                          "type": "view",
                          "props": {
                            "needTitle": true,
                            "titleEn": "Key Metrics",
                            "titleCn": "关键指标",
                            "loadingTargetNames": [
                              "CommonRow"
                            ],
                            "switchDataLoadingHeight": 232,
                            "switchSlot": {
                              "name": "SegmentCo",
                              "className": "segment-light",
                              "style": {
                                "marginLeft": "10px"
                              },
                              "props": {
                                "childrenRenderMode": "byDataKey",
                                "childrenDataKey": "by_tab",
                                "childrenMatchField": "id",
                                "config": {
                                  "dataKey": "by_tab",
                                  "options": [
                                    {
                                      "name": "Gross",
                                      "nameCn": "总口径",
                                      "value": "gross",
                                      "info": {
                                        "textEn": "Under the Gross basis, revenue and sales units are shown in full values.",
                                        "textCn": "Gross口径下，收入、销量均展示全量数据。",
                                        "showIcon": false
                                      }
                                    },
                                    {
                                      "name": "Net",
                                      "nameCn": "去除退款口径",
                                      "value": "net",
                                      "info": {
                                        "textEn": "Under the Net basis, the revenue is calculated as the net revenue, which is the gross revenue minus the refund and tax, after deducting the platform fees. Sales units are calculated excluding refunds.",
                                        "textCn": "Net口径下，收入展示剔除退款和税费并扣除平台分成后的数据；销量展示剔除退款后的数据。",
                                        "showIcon": false
                                      }
                                    }
                                  ]
                                }
                              },
                              "children": [
                                {
                                  "id": "gross",
                                  "name": "LifetimeCardContainer",
                                  "children": [
                                    {
                                      "name": "CommonRow",
                                      "className": "dbd-sales-overview-card-row",
                                      "type": "layout",
                                      "style": {},
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "CommonCol",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "monetization/salesOverview",
                                              "componentKey": "GrossRevenuePlatformCard",
                                              "config": {
                                                "props": {
                                                  "dimension": "catalog"
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonCol",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "monetization/salesOverview",
                                              "componentKey": "GrossFullGameUnitsPlatformCard",
                                              "config": {
                                                "props": {
                                                  "dimension": "catalog"
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SegmentTabsCo",
                                      "data": {
                                        "metric": "gross_revenue"
                                      },
                                      "props": {
                                        "config": {
                                          "dataKey": "metric",
                                          "tabList": {
                                            "Day": [
                                              {
                                                "id": "gross_revenue",
                                                "indicatorsName": "gross_revenue",
                                                "resName": "gross_revenue",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_revenue.en}}($)",
                                                "nameCn": "{{metricsInfo.gross_revenue.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "gross_full_game_units",
                                                "indicatorsName": "gross_full_game_units",
                                                "resName": "gross_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.gross_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              }
                                            ],
                                            "Week": [
                                              {
                                                "id": "gross_revenue",
                                                "indicatorsName": "gross_revenue",
                                                "resName": "gross_revenue",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_revenue.en}}($)",
                                                "nameCn": "{{metricsInfo.gross_revenue.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "gross_full_game_units",
                                                "indicatorsName": "gross_full_game_units",
                                                "resName": "gross_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.gross_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              }
                                            ],
                                            "Month": [
                                              {
                                                "id": "gross_revenue",
                                                "indicatorsName": "gross_revenue",
                                                "resName": "gross_revenue",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_revenue.en}}($)",
                                                "nameCn": "{{metricsInfo.gross_revenue.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "gross_full_game_units",
                                                "indicatorsName": "gross_full_game_units",
                                                "resName": "gross_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.gross_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.gross_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              }
                                            ]
                                          },
                                          "isShowCollapseButton": false
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "SalesBreakdownCardService",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "data": {
                                            "selectedRegion": "us"
                                          },
                                          "props": {
                                            "config": {
                                              "api": "/api/v1/dashboard/pc/monetization/sales/overview/trends",
                                              "dataKey": "trends_data",
                                              "metrics": [
                                                "gross_revenue",
                                                "gross_full_game_units"
                                              ],
                                              "otherParams": "function(data) {const isHavePaymentType = data?.custom_filters?.find(item => item.key === 'payment_type');}"
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "SalesTrendChart",
                                              "config": {
                                                "isHideDiscount": true,
                                                "isHideDimensionSelector": true,
                                                "fixedDimensionValue": "catalog",
                                                "customAccumulation": [
                                                  {
                                                    "key": "catalog",
                                                    "is_accumulation": true
                                                  }
                                                ],
                                                "dimensionColumnName": {
                                                  "en": "Catalog",
                                                  "cn": "Catalog"
                                                },
                                                "componentMetrics": {
                                                  "gross_revenue": {
                                                    "id": "gross_revenue",
                                                    "name": "{{metricsInfo.gross_revenue.en}}($)",
                                                    "nameCn": "{{metricsInfo.gross_revenue.cn}}($)",
                                                    "formatRule": "{{metricsInfo.gross_revenue.formatter}}",
                                                    "correspondingId": "gross_full_game_units",
                                                    "isNoSum": true,
                                                    "countrySelectTop": {
                                                      "barChart": 500,
                                                      "lineChart": 490
                                                    },
                                                    "isHaveShare": true,
                                                    "shareFormat": "percent1Decimal"
                                                  },
                                                  "gross_full_game_units": {
                                                    "id": "gross_full_game_units",
                                                    "name": "{{metricsInfo.gross_full_game_units.en}}",
                                                    "nameCn": "{{metricsInfo.gross_full_game_units.cn}}",
                                                    "formatRule": "{{metricsInfo.gross_full_game_units.formatter}}",
                                                    "correspondingId": "gross_revenue",
                                                    "isNoSum": true,
                                                    "countrySelectTop": {
                                                      "barChart": 500,
                                                      "lineChart": 490
                                                    },
                                                    "isHaveShare": true,
                                                    "shareFormat": "percent1Decimal"
                                                  }
                                                },
                                                "otherParams": "function(data) {const isHavePaymentType = data?.custom_filters?.find(item => item.key === 'payment_type');}"
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "FormattedService",
                                      "props": {
                                        "api": "/api/v1/dashboard/pc/monetization/sales/overview/multi_metrics_breakdown",
                                        "trackData": [
                                          "filter",
                                          "gameCode",
                                          "platform_country_dimension"
                                        ],
                                        "dataKey": "platformCountryTableDataGross",
                                        "metrics": [
                                          "gross_revenue",
                                          "gross_full_game_units"
                                        ],
                                        "extralParams": {
                                          "top_metric": "gross_revenue",
                                          "logical_flag": "breakdown_v2,show_all_data"
                                        },
                                        "beforeRequest": "function(params, data) {\n  const dimession = data?.platform_country_dimension;\n  return Object.assign({}, params || {}, {\n    \"accumulation\": {\n      \"by_system\": dimession === 'platform',\n      \"by_country\": dimession === 'country',\n    }\n  });\n}",
                                        "formatData": "function(res) {\n  const list = res?.dwm_list || res?.data?.dwm_list || [];\n\n  return list.map((row) => {\n    const metrics = row?.metrics || {};\n    const grossRevenue = metrics?.gross_revenue || {};\n    const grossUnits = metrics?.gross_full_game_units || {};\n\n    return {\n      system: row?.name || '',\n      country: row?.name || '',\n      gross_revenue: grossRevenue?.value,\n      gross_revenue_dod: grossRevenue?.dod,\n      gross_revenue_percentage: grossRevenue?.share_off_all,\n      gross_full_game_units: grossUnits?.value,\n      gross_full_game_units_dod: grossUnits?.dod,\n      gross_full_game_units_percentage: grossUnits?.share_off_all\n    };\n  });\n}"
                                      },
                                      "children": [
                                        {
                                          "name": "PlatformCountryTableTransfer",
                                          "className": "margin-t-20 dbd-common-table-transfer-dimessions",
                                          "props": {
                                            "dataKey": "platformCountryTableDataGross",
                                            "tabConfig": {
                                              "titleMap": {
                                                "platform": {
                                                  "titleEn": "Gross Revenue($) & Gross Base Game Units By Platform",
                                                  "titleCn": "总收入($)&本体总销量-分平台"
                                                },
                                                "country": {
                                                  "titleEn": "Gross Revenue($) & Gross Base Game Units By Country",
                                                  "titleCn": "总收入($)&本体总销量-分国家"
                                                }
                                              }
                                            },
                                            "segmentConfig": {
                                              "name": "SegmentCo",
                                              "props": {
                                                "className": "segment-light dbd-segment-more-sales-table",
                                                "config": {
                                                  "dataKey": "platform_country_dimension",
                                                  "options": [
                                                    {
                                                      "name": "Platform",
                                                      "nameCn": "平台",
                                                      "value": "platform",
                                                      "bubble": "",
                                                      "bubbleCn": ""
                                                    },
                                                    {
                                                      "name": "Country",
                                                      "nameCn": "国家",
                                                      "value": "country",
                                                      "bubble": "",
                                                      "bubbleCn": ""
                                                    }
                                                  ]
                                                }
                                              }
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "CommonTable",
                                              "className": "dbd-sales-overview-art-table",
                                              "props": {
                                                "dataKey": "platformCountryTableDataGross",
                                                "metricsCardWrapProps": {
                                                  "link": false,
                                                  "operation": [
                                                    {
                                                      "name": "DownloadButton",
                                                      "className": "dbd-common-table__operation-btn",
                                                      "config": {
                                                        "fileNameEn": "Gross Revenue & Base Game Units By Platform/Country",
                                                        "fileNameCn": "总收入&本体总销量-分平台/国家"
                                                      }
                                                    }
                                                  ]
                                                },
                                                "commonBaseTableProps": {
                                                  "height": 300,
                                                  "componentMetrics": [
                                                    {
                                                      "metricKey": "system",
                                                      "reqMetricKey": "system",
                                                      "enName": "Platform",
                                                      "cnName": "平台",
                                                      "align": "left",
                                                      "enWidth": 150,
                                                      "cnWidth": 110,
                                                      "formatRule": "",
                                                      "type": "string",
                                                      "features": {
                                                        "cell": {
                                                          "type": "system",
                                                          "downloadConvertType": "system"
                                                        }
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "country",
                                                      "reqMetricKey": "country",
                                                      "enName": "Country",
                                                      "cnName": "国家",
                                                      "enWidth": 190,
                                                      "cnWidth": 110,
                                                      "formatRule": "",
                                                      "type": "string",
                                                      "align": "left",
                                                      "features": {
                                                        "cell": {
                                                          "type": "country",
                                                          "downloadConvertType": "country"
                                                        }
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "gross_revenue",
                                                      "reqMetricKey": "gross_revenue",
                                                      "enName": "{{metricsInfo.gross_revenue.en}}($)",
                                                      "cnName": "{{metricsInfo.gross_revenue.cn}}($)",
                                                      "enWidth": 160,
                                                      "cnWidth": 160,
                                                      "rainbowKey": "Pc Gross Revenue",
                                                      "formatRule": "{{metricsInfo.gross_revenue.formatter}}",
                                                      "type": "decimals",
                                                      "decimal": 2,
                                                      "features": {
                                                        "cell": {
                                                          "showChangeRate": true,
                                                          "changeKey": "gross_revenue_dod",
                                                          "dodDecimals": 1,
                                                          "dodDownloadFormat": "0.0%"
                                                        },
                                                        "downLoadFormat": "0.00"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "gross_revenue_percentage",
                                                      "reqMetricKey": "gross_revenue_percentage",
                                                      "enName": "Gross Revenue Share %",
                                                      "cnName": "净收入占比%",
                                                      "enWidth": 200,
                                                      "cnWidth": 200,
                                                      "formatRule": "percent1Decimal",
                                                      "type": "percent",
                                                      "decimal": 1,
                                                      "features": {
                                                        "cell": {
                                                          "type": "percentage",
                                                          "showProgressBar": true
                                                        },
                                                        "downLoadFormat": "0.0%"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "gross_full_game_units",
                                                      "reqMetricKey": "gross_full_game_units",
                                                      "enName": "{{metricsInfo.gross_full_game_units.en}}",
                                                      "cnName": "{{metricsInfo.gross_full_game_units.cn}}",
                                                      "enWidth": 160,
                                                      "cnWidth": 160,
                                                      "rainbowKey": "Pc Gross Base Game Units",
                                                      "formatRule": "{{metricsInfo.gross_full_game_units.formatter}}",
                                                      "type": "int",
                                                      "decimal": 0,
                                                      "features": {
                                                        "cell": {
                                                          "showChangeRate": true,
                                                          "changeKey": "gross_full_game_units_dod",
                                                          "dodDecimals": 1,
                                                          "dodDownloadFormat": "0.0%"
                                                        },
                                                        "downLoadFormat": "#,##0"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "gross_full_game_units_percentage",
                                                      "reqMetricKey": "gross_full_game_units_percentage",
                                                      "enName": "Gross Base Game Units Share %",
                                                      "cnName": "本体总销量占比%",
                                                      "enWidth": 230,
                                                      "cnWidth": 230,
                                                      "formatRule": "percent1Decimal",
                                                      "type": "percent",
                                                      "decimal": 1,
                                                      "features": {
                                                        "cell": {
                                                          "type": "percentage",
                                                          "showProgressBar": true
                                                        },
                                                        "downLoadFormat": "0.0%"
                                                      }
                                                    }
                                                  ],
                                                  "tableMetric": [
                                                    "gross_revenue",
                                                    "gross_revenue_percentage",
                                                    "gross_full_game_units",
                                                    "gross_full_game_units_percentage"
                                                  ],
                                                  "tableConfig": {
                                                    "primaryKey": "system",
                                                    "isOpenForegroundPage": true,
                                                    "pagination": {
                                                      "pageSize": 10,
                                                      "pageIndex": 1
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SalesOverviewSalesBreakDownServiceTransfer",
                                      "props": {
                                        "tabMapConfig": {
                                          "gross": {
                                            "metric": [
                                              "gross_revenue",
                                              "gross_full_game_units"
                                            ],
                                            "topMetric": "gross_revenue",
                                            "extMetricMap": {
                                              "gross_revenue": "gross_full_game_units",
                                              "gross_full_game_units": "gross_revenue"
                                            }
                                          }
                                        },
                                        "config": {
                                          "api": "/api/v1/dashboard/pc/monetization/sales/overview/multi_metrics_breakdown",
                                          "byType": "function(type) {\n                                        return type === 'product' ? 'by_product' : 'by_category';\n                                    }",
                                          "extraParams": {
                                            "top_num": 30
                                          }
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "CommonRow",
                                          "className": "dbd-saleOverview-row dbd-saleOverview-breakdown-row",
                                          "type": "layout",
                                          "style": {
                                            "marginTop": 0,
                                            "marginBottom": 0
                                          },
                                          "props": {},
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "className": "dbd-ingame-revenue-breakdown dbd-lifetime-sales-breakdown margin-t-10",
                                              "type": "layout",
                                              "style": {},
                                              "props": {},
                                              "children": [
                                                {
                                                  "name": "IngameDlpTopChartContextTransfer",
                                                  "props": {
                                                    "tabConfigMap": {
                                                      "gross": {
                                                        "segmentConfig": {
                                                          "dataKey": "by_type",
                                                          "options": [
                                                            {
                                                              "name": "Product",
                                                              "nameCn": "产品",
                                                              "value": "product",
                                                              "bubble": "",
                                                              "bubbleCn": ""
                                                            },
                                                            {
                                                              "name": "Product Category",
                                                              "nameCn": "产品类型",
                                                              "value": "category",
                                                              "bubble": "",
                                                              "bubbleCn": ""
                                                            }
                                                          ]
                                                        },
                                                        "top10TitleEn": "function(type) {\n                                                                    return type === 'product' ? 'TOP 30 SKU/Bundle' : 'TOP 30 Product Category';\n                                                                }",
                                                        "top10TitleCn": "function(type) {\n                                                                    return type === 'product' ? 'TOP 30 SKU/Bundle' : 'TOP 30 产品类型';\n                                                                }",
                                                        "titleNameEn": "function(type) {\n                                                                    return type === 'product' ? 'Product' : 'Product Category';\n                                                                }",
                                                        "titleNameCn": "function(type) {\n                                                                    return type === 'product' ? '产品' : '产品类型';\n                                                                }",
                                                        "sortMetric": "gross_revenue",
                                                        "chart": [
                                                          {
                                                            "metric": "gross_revenue",
                                                            "name": "{{metricsInfo.gross_revenue.en}}($)",
                                                            "nameCn": "{{metricsInfo.gross_revenue.cn}}($)",
                                                            "format": "{{metricsInfo.gross_revenue.formatter}}",
                                                            "percentFormat": "percent1Decimal"
                                                          },
                                                          {
                                                            "metric": "gross_full_game_units",
                                                            "name": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.gross_full_game_units.en}}' : 'Gross Units';\n                                                                }",
                                                            "nameCn": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.gross_full_game_units.cn}}' : '总销量';\n                                                                }",
                                                            "format": "{{metricsInfo.gross_full_game_units.formatter}}",
                                                            "percentFormat": "percent1Decimal"
                                                          }
                                                        ],
                                                        "download": [
                                                          {
                                                            "key": "full_name",
                                                            "header": "HEADER"
                                                          },
                                                          {
                                                            "key": "gross_revenue",
                                                            "header": "{{metricsInfo.gross_revenue.en}}($)",
                                                            "headerCn": "{{metricsInfo.gross_revenue.cn}}($)"
                                                          },
                                                          {
                                                            "key": "gross_revenue_percentage",
                                                            "header": "Share of All ({{metricsInfo.gross_revenue.en}})",
                                                            "headerCn": "全局占比({{metricsInfo.gross_revenue.cn}})"
                                                          },
                                                          {
                                                            "key": "gross_full_game_units",
                                                            "header": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.gross_full_game_units.en}}' : 'Gross Units';\n                                                                }",
                                                            "headerCn": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.gross_full_game_units.cn}}' : '总销量';\n                                                                }"
                                                          },
                                                          {
                                                            "key": "gross_full_game_units_percentage",
                                                            "header": "function(type) {\n                                                                    return type === 'product' ? 'Share of All ({{metricsInfo.gross_full_game_units.en}})' : 'Share of All (Gross Units)';\n                                                                }",
                                                            "headerCn": "function(type) {\n                                                                    return type === 'product' ? '全局占比({{metricsInfo.gross_full_game_units.cn}})' : '全局占比(总销量)';\n                                                                }"
                                                          }
                                                        ],
                                                        "isBasicSelector": true
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "id": "net",
                                  "name": "LifetimeCardContainer",
                                  "children": [
                                    {
                                      "name": "CommonRow",
                                      "className": "dbd-sales-overview-card-row",
                                      "type": "layout",
                                      "style": {},
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "CommonCol",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "monetization/salesOverview",
                                              "componentKey": "ProfitPlatformCard",
                                              "config": {
                                                "props": {
                                                  "dimension": "catalog"
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonCol",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "monetization/salesOverview",
                                              "componentKey": "NetFullGameUnitsPlatformCard",
                                              "config": {
                                                "props": {
                                                  "dimension": "catalog"
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonRow",
                                      "className": "dbd-sales-overview-card-row margin-t-10",
                                      "type": "layout",
                                      "style": {},
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "CommonCol",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {
                                            "w": 24
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "monetization/salesOverview",
                                              "componentKey": "RefundRatePlatformCard",
                                              "config": {
                                                "props": {
                                                  "dimension": "catalog"
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SegmentTabsCo",
                                      "data": {
                                        "metric": "profit"
                                      },
                                      "props": {
                                        "config": {
                                          "dataKey": "metric",
                                          "tabList": {
                                            "Day": [
                                              {
                                                "id": "profit",
                                                "indicatorsName": "profit",
                                                "resName": "profit",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.profit.en}}($)",
                                                "nameCn": "{{metricsInfo.profit.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "net_full_game_units",
                                                "indicatorsName": "net_full_game_units",
                                                "resName": "net_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.net_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.net_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "avg_net_price",
                                                "indicatorsName": "avg_net_price",
                                                "resName": "avg_net_price",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.avg_net_price.en}}($)",
                                                "nameCn": "{{metricsInfo.avg_net_price.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              }
                                            ],
                                            "Week": [
                                              {
                                                "id": "profit",
                                                "indicatorsName": "profit",
                                                "resName": "profit",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.profit.en}}($)",
                                                "nameCn": "{{metricsInfo.profit.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "net_full_game_units",
                                                "indicatorsName": "net_full_game_units",
                                                "resName": "net_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.net_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.net_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "avg_net_price",
                                                "indicatorsName": "avg_net_price",
                                                "resName": "avg_net_price",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.avg_net_price.en}}($)",
                                                "nameCn": "{{metricsInfo.avg_net_price.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              }
                                            ],
                                            "Month": [
                                              {
                                                "id": "profit",
                                                "indicatorsName": "profit",
                                                "resName": "profit",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.profit.en}}($)",
                                                "nameCn": "{{metricsInfo.profit.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "net_full_game_units",
                                                "indicatorsName": "net_full_game_units",
                                                "resName": "net_full_game_units",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.net_full_game_units.en}}",
                                                "nameCn": "{{metricsInfo.net_full_game_units.cn}}",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": true,
                                                "dodDecimals": 1
                                              },
                                              {
                                                "id": "avg_net_price",
                                                "indicatorsName": "avg_net_price",
                                                "resName": "avg_net_price",
                                                "resAvgName": "",
                                                "name": "{{metricsInfo.avg_net_price.en}}($)",
                                                "nameCn": "{{metricsInfo.avg_net_price.cn}}($)",
                                                "avgName": "",
                                                "isPercent": false,
                                                "decimals": 0,
                                                "isUserType": false,
                                                "dodDecimals": 1
                                              }
                                            ]
                                          },
                                          "isShowCollapseButton": false
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "SalesBreakdownCardService",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "data": {
                                            "selectedRegion": "us"
                                          },
                                          "props": {
                                            "config": {
                                              "api": "/api/v1/dashboard/pc/monetization/sales/overview/trends",
                                              "dataKey": "trends_data",
                                              "metrics": [
                                                "profit",
                                                "net_full_game_units",
                                                "avg_net_price"
                                              ],
                                              "otherParams": "function(data) {const isHavePaymentType = data?.custom_filters?.find(item => item.key === 'payment_type');}"
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "SalesTrendChart",
                                              "config": {
                                                "isHideDiscount": true,
                                                "isHideDimensionSelector": true,
                                                "fixedDimensionValue": "catalog",
                                                "customAccumulation": [
                                                  {
                                                    "key": "catalog",
                                                    "is_accumulation": true
                                                  }
                                                ],
                                                "dimensionColumnName": {
                                                  "en": "Catalog",
                                                  "cn": "Catalog"
                                                },
                                                "componentMetrics": {
                                                  "profit": {
                                                    "id": "profit",
                                                    "name": "{{metricsInfo.profit.en}}($)",
                                                    "nameCn": "{{metricsInfo.profit.cn}}($)",
                                                    "formatRule": "{{metricsInfo.profit.formatter}}",
                                                    "correspondingId": "net_full_game_units",
                                                    "countrySelectTop": {
                                                      "barChart": 500,
                                                      "lineChart": 490
                                                    },
                                                    "isNoSum": true,
                                                    "isHaveShare": true,
                                                    "shareFormat": "percent1Decimal"
                                                  },
                                                  "net_full_game_units": {
                                                    "id": "net_full_game_units",
                                                    "name": "{{metricsInfo.net_full_game_units.en}}",
                                                    "nameCn": "{{metricsInfo.net_full_game_units.cn}}",
                                                    "formatRule": "{{metricsInfo.net_full_game_units.formatter}}",
                                                    "correspondingId": "profit",
                                                    "countrySelectTop": {
                                                      "barChart": 500,
                                                      "lineChart": 490
                                                    },
                                                    "isNoSum": true,
                                                    "isHaveShare": true,
                                                    "shareFormat": "percent1Decimal"
                                                  },
                                                  "avg_net_price": {
                                                    "id": "avg_net_price",
                                                    "name": "{{metricsInfo.avg_net_price.en}}($)",
                                                    "nameCn": "{{metricsInfo.avg_net_price.cn}}($)",
                                                    "formatRule": "{{metricsInfo.avg_net_price.formatter}}",
                                                    "isUserType": false,
                                                    "isHideSum": true,
                                                    "isPercent": false,
                                                    "countrySelectTop": {
                                                      "barChart": 500,
                                                      "lineChart": 490
                                                    }
                                                  }
                                                },
                                                "otherParams": "function(data) {const isHavePaymentType = data?.custom_filters?.find(item => item.key === 'payment_type');}"
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "FormattedService",
                                      "props": {
                                        "api": "/api/v1/dashboard/pc/monetization/sales/overview/multi_metrics_breakdown",
                                        "trackData": [
                                          "filter",
                                          "gameCode",
                                          "platform_country_dimension"
                                        ],
                                        "dataKey": "platformCountryTableData",
                                        "metrics": [
                                          "net_full_game_units",
                                          "profit"
                                        ],
                                        "extralParams": {
                                          "top_metric": "gross_revenue",
                                          "logical_flag": "breakdown_v2,show_all_data"
                                        },
                                        "beforeRequest": "function(params, data) {\n  const dimession = data?.platform_country_dimension;\n  return Object.assign({}, params || {}, {\n    \"accumulation\": {\n      \"by_system\": dimession === 'platform',\n      \"by_country\": dimession === 'country'\n    }\n  });\n}",
                                        "formatData": "function(res) {\n  const list = res?.dwm_list || res?.data?.dwm_list || [];\n\n  return list.map((row) => {\n    const metrics = row?.metrics || {};\n    const netUnits = metrics?.net_full_game_units || {};\n    const netRevenue = metrics?.profit || {};\n\n    return {\n      system: row?.name || '',\n      country: row?.name || '',\n      net_full_game_units: netUnits?.value,\n      units_number_dod: netUnits?.dod,\n      units_number_percentage: netUnits?.share_off_all,\n      profit: netRevenue?.value,\n      revenue_after_chargeback_dod: netRevenue?.dod,\n      revenue_after_chargeback_percentage: netRevenue?.share_off_all\n    };\n  });\n}"
                                      },
                                      "children": [
                                        {
                                          "name": "PlatformCountryTableTransfer",
                                          "className": "margin-t-20 dbd-common-table-transfer-dimessions",
                                          "props": {
                                            "dataKey": "platformCountryTableData",
                                            "tabConfig": {
                                              "titleMap": {
                                                "platform": {
                                                  "titleEn": "Net Revenue($) & Net Base Game Units By Platform",
                                                  "titleCn": "净收入($)&净本体销量-分平台"
                                                },
                                                "country": {
                                                  "titleEn": "Net Revenue($) & Net Base Game Units By Country",
                                                  "titleCn": "净收入($)&净本体销量-分国家"
                                                }
                                              }
                                            },
                                            "segmentConfig": {
                                              "name": "SegmentCo",
                                              "props": {
                                                "className": "segment-light dbd-segment-more-sales-table",
                                                "config": {
                                                  "dataKey": "platform_country_dimension",
                                                  "options": [
                                                    {
                                                      "name": "Platform",
                                                      "nameCn": "平台",
                                                      "value": "platform",
                                                      "bubble": "",
                                                      "bubbleCn": ""
                                                    },
                                                    {
                                                      "name": "Country",
                                                      "nameCn": "国家",
                                                      "value": "country",
                                                      "bubble": "",
                                                      "bubbleCn": ""
                                                    }
                                                  ]
                                                }
                                              }
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "CommonTable",
                                              "className": "dbd-sales-overview-art-table",
                                              "props": {
                                                "dataKey": "platformCountryTableData",
                                                "metricsCardWrapProps": {
                                                  "link": false,
                                                  "operation": [
                                                    {
                                                      "name": "DownloadButton",
                                                      "className": "dbd-common-table__operation-btn",
                                                      "config": {
                                                        "fileNameEn": "Net Revenue & Base Game Units By Platform/Country",
                                                        "fileNameCn": "净收入&净本体销量-分平台/国家"
                                                      }
                                                    }
                                                  ]
                                                },
                                                "commonBaseTableProps": {
                                                  "height": 300,
                                                  "componentMetrics": [
                                                    {
                                                      "metricKey": "system",
                                                      "reqMetricKey": "system",
                                                      "enName": "Platform",
                                                      "cnName": "平台",
                                                      "enWidth": 150,
                                                      "cnWidth": 110,
                                                      "align": "left",
                                                      "formatRule": "",
                                                      "type": "string",
                                                      "features": {
                                                        "cell": {
                                                          "type": "system",
                                                          "downloadConvertType": "system"
                                                        }
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "country",
                                                      "reqMetricKey": "country",
                                                      "enName": "Country",
                                                      "cnName": "国家",
                                                      "enWidth": 190,
                                                      "cnWidth": 110,
                                                      "align": "left",
                                                      "formatRule": "",
                                                      "type": "string",
                                                      "features": {
                                                        "cell": {
                                                          "type": "country",
                                                          "downloadConvertType": "country"
                                                        }
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "profit",
                                                      "reqMetricKey": "profit",
                                                      "enName": "{{metricsInfo.profit.en}}($)",
                                                      "cnName": "{{metricsInfo.profit.cn}}($)",
                                                      "enWidth": 160,
                                                      "cnWidth": 160,
                                                      "rainbowKey": "Pc Revenue After Refund($)",
                                                      "formatRule": "thousands2Decimal",
                                                      "type": "decimals",
                                                      "decimal": 2,
                                                      "features": {
                                                        "cell": {
                                                          "showChangeRate": true,
                                                          "changeKey": "revenue_after_chargeback_dod",
                                                          "dodDecimals": 1,
                                                          "dodDownloadFormat": "0.0%"
                                                        },
                                                        "downLoadFormat": "0.00"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "revenue_after_chargeback_percentage",
                                                      "reqMetricKey": "revenue_after_chargeback_percentage",
                                                      "enName": "Net Revenue Share %",
                                                      "cnName": "净收入占比%",
                                                      "enWidth": 180,
                                                      "cnWidth": 180,
                                                      "formatRule": "percent1Decimal",
                                                      "type": "percent",
                                                      "decimal": 1,
                                                      "features": {
                                                        "cell": {
                                                          "type": "percentage",
                                                          "showProgressBar": true
                                                        },
                                                        "downLoadFormat": "0.0%"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "net_full_game_units",
                                                      "reqMetricKey": "net_full_game_units",
                                                      "enName": "{{metricsInfo.net_full_game_units.en}}",
                                                      "cnName": "{{metricsInfo.net_full_game_units.cn}}",
                                                      "enWidth": 160,
                                                      "cnWidth": 160,
                                                      "rainbowKey": "Pc Base Game Units After Refund",
                                                      "formatRule": "{{metricsInfo.net_full_game_units.formatter}}",
                                                      "type": "int",
                                                      "decimal": 0,
                                                      "features": {
                                                        "cell": {
                                                          "showChangeRate": true,
                                                          "changeKey": "units_number_dod",
                                                          "dodDecimals": 1,
                                                          "dodDownloadFormat": "0.0%"
                                                        },
                                                        "downLoadFormat": "#,##0"
                                                      }
                                                    },
                                                    {
                                                      "metricKey": "units_number_percentage",
                                                      "reqMetricKey": "units_number_percentage",
                                                      "enName": "Net Base Game Units Share%",
                                                      "cnName": "本体净销量占比%",
                                                      "enWidth": 210,
                                                      "cnWidth": 210,
                                                      "formatRule": "percent1Decimal",
                                                      "type": "percent",
                                                      "decimal": 1,
                                                      "features": {
                                                        "cell": {
                                                          "type": "percentage",
                                                          "showProgressBar": true
                                                        },
                                                        "downLoadFormat": "0.0%"
                                                      }
                                                    }
                                                  ],
                                                  "tableMetric": [
                                                    "profit",
                                                    "revenue_after_chargeback_percentage",
                                                    "net_full_game_units",
                                                    "units_number_percentage"
                                                  ],
                                                  "tableConfig": {
                                                    "isOpenForegroundPage": true,
                                                    "pagination": {
                                                      "pageSize": 10,
                                                      "pageIndex": 1
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SalesOverviewSalesBreakDownServiceTransfer",
                                      "props": {
                                        "tabMapConfig": {
                                          "net": {
                                            "metric": [
                                              "profit",
                                              "net_full_game_units"
                                            ],
                                            "topMetric": "profit",
                                            "extMetricMap": {
                                              "profit": "net_full_game_units",
                                              "net_full_game_units": "profit"
                                            }
                                          }
                                        },
                                        "config": {
                                          "api": "/api/v1/dashboard/pc/monetization/sales/overview/multi_metrics_breakdown",
                                          "byType": "function(type) {\n                                        return type === 'product' ? 'by_product' : 'by_category';\n                                    }",
                                          "extraParams": {
                                            "top_num": 30,
                                            "logical_flag": "breakdown_v2,overall_pre_not_query"
                                          }
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "CommonRow",
                                          "className": "dbd-saleOverview-row dbd-saleOverview-breakdown-row",
                                          "type": "layout",
                                          "style": {
                                            "marginTop": 0,
                                            "marginBottom": 0
                                          },
                                          "props": {},
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "className": "dbd-ingame-revenue-breakdown dbd-lifetime-sales-breakdown margin-t-10",
                                              "type": "layout",
                                              "style": {},
                                              "props": {},
                                              "children": [
                                                {
                                                  "name": "IngameDlpTopChartContextTransfer",
                                                  "props": {
                                                    "tabConfigMap": {
                                                      "net": {
                                                        "segmentConfig": {
                                                          "dataKey": "by_type",
                                                          "options": [
                                                            {
                                                              "name": "Product",
                                                              "nameCn": "产品",
                                                              "value": "product",
                                                              "bubble": "",
                                                              "bubbleCn": ""
                                                            },
                                                            {
                                                              "name": "Product Category",
                                                              "nameCn": "产品类型",
                                                              "value": "category",
                                                              "bubble": "",
                                                              "bubbleCn": ""
                                                            }
                                                          ]
                                                        },
                                                        "top10TitleEn": "function(type) {\n                                                                    return type === 'product' ? 'TOP 30 SKU/Bundle' : 'TOP 30 Product Category';\n                                                                }",
                                                        "top10TitleCn": "function(type) {\n                                                                    return type === 'product' ? 'TOP 30 SKU/Bundle' : 'TOP 30 产品类型';\n                                                                }",
                                                        "titleNameEn": "function(type) {\n                                                                    return type === 'product' ? 'Product' : 'Product Category';\n                                                                }",
                                                        "titleNameCn": "function(type) {\n                                                                    return type === 'product' ? '产品' : '产品类型';\n                                                                }",
                                                        "sortMetric": "profit",
                                                        "chart": [
                                                          {
                                                            "metric": "profit",
                                                            "name": "{{metricsInfo.profit.en}}($)",
                                                            "nameCn": "{{metricsInfo.profit.cn}}($)",
                                                            "format": "{{metricsInfo.profit.formatter}}",
                                                            "percentFormat": "percent1Decimal"
                                                          },
                                                          {
                                                            "metric": "net_full_game_units",
                                                            "name": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.net_full_game_units.en}}' : 'Net Units';\n                                                                }",
                                                            "nameCn": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.net_full_game_units.cn}}' : '净销量';\n                                                                }",
                                                            "format": "{{metricsInfo.net_full_game_units.formatter}}",
                                                            "percentFormat": "percent1Decimal"
                                                          }
                                                        ],
                                                        "download": [
                                                          {
                                                            "key": "full_name",
                                                            "header": "HEADER"
                                                          },
                                                          {
                                                            "key": "profit",
                                                            "header": "{{metricsInfo.profit.en}}($)",
                                                            "headerCn": "{{metricsInfo.profit.cn}}($)"
                                                          },
                                                          {
                                                            "key": "profit_percentage",
                                                            "header": "Share of All ({{metricsInfo.profit.en}})",
                                                            "headerCn": "全局占比({{metricsInfo.profit.cn}})"
                                                          },
                                                          {
                                                            "key": "net_full_game_units",
                                                            "header": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.net_full_game_units.en}}' : 'Net Units';\n                                                                }",
                                                            "headerCn": "function(type) {\n                                                                    return type === 'product' ? '{{metricsInfo.net_full_game_units.cn}}' : '净销量';\n                                                                }"
                                                          },
                                                          {
                                                            "key": "net_full_game_units_percentage",
                                                            "header": "function(type) {\n                                                                    return type === 'product' ? 'Share of All ({{metricsInfo.net_full_game_units.en}})' : 'Share of All (Net Units)';\n                                                                }",
                                                            "headerCn": "function(type) {\n                                                                    return type === 'product' ? '全局占比({{metricsInfo.net_full_game_units.cn}})' : '全局占比(净销量)';\n                                                                }"
                                                          }
                                                        ],
                                                        "isBasicSelector": true
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "monetization/salesOverview",
                      "componentKey": "OverallTableCo",
                      "data": {
                        "tableMetric": [
                          "profit",
                          "net_full_game_units",
                          "gross_revenue",
                          "gross_full_game_units",
                          "gross_units_sold",
                          "net_units_sold",
                          "lifetime_gross_revenue",
                          "lifetime_profit",
                          "lifetime_gross_units",
                          "lifetime_net_units",
                          "lifetime_full_game_gross_units",
                          "lifetime_full_game_net_units",
                          "lifetime_refund_rate",
                          "refund_revenue",
                          "refunded_units",
                          "refund_rate",
                          "avg_net_price",
                          "asp"
                        ]
                      },
                      "config": {
                        "props": {
                          "config": {
                            "lockColumns": [
                              {
                                "key": "date",
                                "lockRainbowKey": "Pc Lock Date Tip",
                                "unlockRainbowKey": "Pc Unlock Date Tip",
                                "showDimList": [
                                  "date"
                                ]
                              }
                            ],
                            "accumulatesConfig": {
                              "product": 450,
                              "catalog": 220
                            },
                            "isUseNewSortParams": true,
                            "isHavePageDefaultSelector": true,
                            "isHaveDiff": false,
                            "pageSizeOptions": [
                              10,
                              20,
                              30,
                              40,
                              50
                            ],
                            "showStatistic": [
                              "sum",
                              "avg_no_null"
                            ],
                            "valueTypeConfig": {
                              "valueType": "value_only",
                              "isShowChange": false,
                              "isShowSdlw": true
                            },
                            "customFiltersConfig": {
                              "customFiltersFromData": [
                                "catalog"
                              ]
                            },
                            "dimensionConfig": {
                              "dateDisabled": false,
                              "defaultAccumulation": [
                                "date",
                                "category",
                                "product"
                              ],
                              "dimensionOptions": [
                                {
                                  "value": "catalog",
                                  "textEn": "By Catalog",
                                  "textCn": "分游戏分类",
                                  "insertIndex": 4
                                }
                              ],
                              "dimensionInfoMap": {
                                "product": {
                                  "en": "The category \"By Product\" includes all products (Base Game, DLC, Bundle, MTX)",
                                  "cn": "分产品维度包含所有产品（本体、DLC、捆绑包、MTX）"
                                }
                              },
                              "isShowCountryFlag": true,
                              "filterDimsAndColumns": [
                                "bundle"
                              ]
                            },
                            "api": {
                              "tableApi": "/api/v1/dashboard/pc/monetization/sales/overview/overall_performance",
                              "tableDownloadApi": "/api/v1/dashboard/pc/monetization/sales/overview/overall_performance/download"
                            },
                            "titleEn": "Overall Payment",
                            "titleCn": "总体付费表现",
                            "defaultSort": [
                              {
                                "by": "profit",
                                "order": "desc"
                              }
                            ]
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          }
        }
      ]
    }
  ]
};
